// third-party
import { combineReducers } from "redux";
import { persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";

// project imports
import snackbarReducer from "./slices/snackbar";
import customerReducer from "./slices/customer";
import userReducer from "./slices/user";
import cartReducer from "./slices/cart";
import menuReducer from "./slices/menu";
import adminuserlist from "./slices/adminUserList";
import UserForm from "./slices/UserForm";
import FormSubmitted from "./slices/formSubmitted";
import adminChallanlist from "./slices/adminChallanList";
import userLogin from "./slices/userLogin";

// ==============================|| COMBINE REDUCER ||============================== //

const reducer = combineReducers({
  snackbar: snackbarReducer,
  cart: persistReducer(
    {
      key: "cart",
      storage,
      keyPrefix: "berry-",
    },
    cartReducer
  ),
  customer: customerReducer,
  user: userReducer,
  menu: menuReducer,
  adminuserlist: adminuserlist,
  UserForm: persistReducer(
    {
      key: "UserForm",
      storage,
      keyPrefix: "berry-",
    },
    UserForm
  ),
  FormSubmitted: FormSubmitted,
  adminChallanlist: persistReducer(
    {
      key: "adminChallan",
      storage,
      keyPrefix: "berry-",
    },
    adminChallanlist
  ),
  userLogin: persistReducer(
    {
      key: "userLogin",
      storage,
      keyPrefix: "berry-",
    },
    userLogin
  ),
});

export default reducer;
